type PostOnboardingExperienceRequestListener = () => void;

const requestListeners = new Set<PostOnboardingExperienceRequestListener>();

export function subscribePostOnboardingExperienceRequest(
  listener: PostOnboardingExperienceRequestListener,
) {
  requestListeners.add(listener);
  return () => {
    requestListeners.delete(listener);
  };
}

export function requestPostOnboardingExperience() {
  requestListeners.forEach((listener) => listener());
}
